import React, { ChangeEvent, useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

interface AppCheckboxProps {
  checked?: boolean;
  disabled?: boolean;
  value?: string;
  id?: string;
  name?: string;
  readOnly?: boolean;
  isAlt?: boolean
  onChecked: (data: boolean) => void;
  text?: string;
  type?: string;
}

export default function ArcCheckbox(props: AppCheckboxProps) {
  const {
    isAlt = false,
    checked,
    disabled = false,
    value = "",
    id = "",
    name = "",
    readOnly = false,
    text = "",
    type = "",
    onChecked,
  } = props;

  const [isCheck, setIsCheck] = useState(checked);

  useEffect(() => {
    setIsCheck(checked ?? false)
  }, [checked]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!readOnly) {
      if (checked) {
        setIsCheck(checked && e.target.checked);
      } else {
        setIsCheck(e.target.checked);
      }
      onChecked(e.target.checked);
    }
  }

  return (
    <span key={`checkbox-${uuid()}`} className={`${props.type == "toggle" ? "" : `checkbox-radio-${isAlt ? "type02" : "type01"}`} `}>
      {props.type == "toggle" ?
        (<>
          <input
            type="checkbox"
            className="sr-only"
            onChange={handleChange}
            readOnly={readOnly}
            checked={isCheck}
            value={value}
            disabled={disabled}
            id={id}
            name={name}
          />
          <label htmlFor={id} onClick={(e) => {
            if (!readOnly) {
              const newChecked = !isCheck;
              setIsCheck(newChecked);
              onChecked(newChecked);
            }
          }}>
            <div className="button">
              <span className="txt"><em>{isCheck ? 'ON' : 'OFF'}</em></span>
              <div className="inside"></div>
            </div>
          </label>
        </>)
        :
        <label>
          <input type="checkbox"
            onChange={handleChange}
            readOnly={readOnly}
            checked={isCheck}
            value={value}
            disabled={disabled}
            id={id}
            name={name} />
          {props.text}
        </label>
      }

    </span>
  )
}